import { Component, OnInit, ViewChild, Input, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { QueryMode } from '@zhongruigroup/ngx-query';
import { map, finalize } from 'rxjs/operators';

import { UnionQueryPara, NgxQueryDynamicComponent } from 'zr-dynamic-form/dynamic-form-designer';
import { NgxDataTableDirective, DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';
import { FormDataService } from 'zr-dynamic-form/dynamic-form-runtime';

@Component({
  selector: 'df-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  @Input() showPatchDelete: boolean = true; // æ¯å¦æ¾ç¤ºæ¹éå é¤

  formCode: string;
  labelCode: string;
  formName: string;
  hidden: boolean = false;

  datatable: DatatableComponent;
  loading: boolean;
  rows: any;
  selectedRows: Array<any> = [];

  queryTemplates: any = [
    {
      name: 'Default',
      template: {
        op: 'and',
        rules: [],
        groups: []
      }
    }
  ];

  mode: QueryMode = QueryMode.plainCollapse;

  @ViewChild('appNgxDataTable') ngxDataTable: NgxDataTableDirective;
  @ViewChild('ngxQueryDynamic') ngxQueryDynamic: NgxQueryDynamicComponent;

  constructor(
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private commonConfig: DynamicFormCommonConfig
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.formCode = params.formCode;
      this.labelCode = params.labelCode;
      this.formDataService.getFormName(this.formCode, this.labelCode).subscribe(
        (s) => {
          this.formName = s;
          if (this.commonConfig.updateTitle && typeof this.commonConfig.updateTitle === 'function') {
            this.commonConfig.updateTitle(this.route.parent, this.formName);
          }
        },
        (error) => {
          this.hidden = true;
          this.commonConfig.log.warn(`${error.error}`);
        }
      );
    });
  }

  // æ¥è¯¢
  loadUnionForms(event: any) {
    const params: any = event.page;
    this.datatable = event.datatable;
    this.loading = true;
    // æ¸é¤å·²éä¸­
    this.selectedRows = [];

    // æ¹åéæ©æ¹å¼ï¼ä¿®å¤é»è®¤å¨éæ¡éä¸­
    this.datatable.selectionType = SelectionType.single;
    const unionPara = this.getUnionQueryPara(params);
    this.formDataService
      .getUnionForms(unionPara as any)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (response) => {
          this.datatable.count = response.count;
          this.rows = response.data || [];
          if (this.datatable.count > 0) {
            this.datatable.selectionType = SelectionType.checkbox;
          }
        },
        (error) => {
          this.commonConfig.log.error(`${error.error}`);
        }
      );
  }
  // æ¹éå é¤
  deletePatch() {
    if (!this.selectedRows || this.selectedRows.length === 0) {
      this.commonConfig.log.warn('è¯·éæ©è¦å é¤çæ°æ®');
      return;
    }

    this.commonConfig.dialog.confirm(`ç¡®è®¤å é¤éä¸­æ°æ®ï¼`).subscribe(() => {
      const targetIds = this.selectedRows.map((s) => s.targetId);
      this.formDataService.deletePatch(this.formCode, targetIds).subscribe(
        (s) => {
          this.ngxDataTable.deleteRefreshData();
          this.commonConfig.log.success(`å é¤æå!`);
        },
        (error) => {
          this.commonConfig.log.error(`å é¤å¤±è´¥,å¤±è´¥ä¿¡æ¯:`, error);
        }
      );
    });
  }

  deleteForm(row: any) {
    this.formDataService.delete(this.formCode, row.targetId).subscribe(
      (s) => {
        this.ngxDataTable.deleteRefreshData();
        this.commonConfig.log.success(`å é¤æå!`);
      },
      (error) => {
        this.commonConfig.log.error(`å é¤å¤±è´¥,å¤±è´¥ä¿¡æ¯:`, error);
      }
    );
  }

  onSelect(event: { selected: Array<any> }) {
    this.selectedRows.splice(0, this.selectedRows.length);
    this.selectedRows.push(...event.selected);
  }

  private getUnionQueryPara(params: any): UnionQueryPara {
    return this.ngxQueryDynamic.getUnionParam(params);
  }
}
